export enum MediaKind {
  RICH_TEXT_IMAGE = "RICH_TEXT_IMAGE",
}

export const MEDIA_PRESIGN_URL = "/media/presign/";

export const IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const IMAGE_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
] as const;
export const IMAGE_ACCEPT = IMAGE_MIME_TYPES.join(",");
export const IMAGE_MAX_WIDTH = 1920;
export const IMAGE_MAX_HEIGHT = 1080;
